import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { zodResolver } from '@hookform/resolvers/zod';

import { useForm } from 'react-hook-form';
import { z } from 'zod';

export const ChangeNameRequestSchema = z.object({
  name: z.string().nonempty('Name is required'),
});

export type ChangeNameRequest = z.infer<typeof ChangeNameRequestSchema>;

export function ChangeNameRequestForm({ onSubmit, onChancel }: any) {
  const form = useForm<ChangeNameRequest>({
    resolver: zodResolver(ChangeNameRequestSchema),
    defaultValues: {
      name: '',
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="name"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormLabel>Name</FormLabel>
              <FormControl>
                <Input
                  autoComplete="off"
                  inError={!!form.formState.errors.name}
                  placeholder="Name"
                  {...field}
                />
              </FormControl>
              <FormMessage>{fieldState.error?.message || ''}</FormMessage>
            </FormItem>
          )}
        />

        <div className="flex gap-4 justify-end">
          <Button type="button" variant="outline" onClick={onChancel}>
            Cancel
          </Button>
          <Button type="submit">Submit</Button>
        </div>
      </form>
    </Form>
  );
}
